import React from 'react';
import { sortBy, filter, startsWith } from 'lodash';
import { msToHour, timeToMs } from '../../../lib/date.utils';
import { get, find } from 'lodash';

const PerformancesRow = ({ newPerformance, performances = [], stage, artists, editPerformance }) => (
    <ul className="ckp-admin-performances">
        <li onClick={() => newPerformance(stage)} className="ckp-ts-h4 ckp-admin-performances-add">
            + Add performance
        </li>
        {sortBy(
            filter(performances || [], p => startsWith(p.date, stage.date)),
            ['startHour', 'endHour']
        ).map(e => {
            const minutes = (timeToMs(e.endHour) - timeToMs(e.startHour)) / 1000 / 60;
            const artist = find(artists, a => a.value === e.artistId);
            return (
                <li
                    style={{ minWidth: `${minutes * 3}px`, width: `${minutes * 3}px` }}
                    className="ckp-admin-performances-entry"
                    key={e.id}
                    onClick={() => editPerformance(e)}
                >
                    <span className="ckp-admin-performances-entry-artist u-bold u-truncate">
                        {get(artist, 'label')}
                    </span>
                    <span className="u-truncate">
                        {msToHour(e.startHour)} - {msToHour(e.endHour)}
                    </span>
                </li>
            );
        })}
    </ul>
);

export default PerformancesRow;
